import React, { useContext, useState } from 'react';
import store from '../../store';
// Custom components
import { EditSettings } from '../../components/Buttons';
import AppHeader from '../../components/AppHeader';
import ChangeUISettings from '../../components/ChangeUISettings';
// Material components
import {
    Grid,
    List,
    ListItem,
    ListItemText,
    Collapse,
    ListItemIcon,
    Divider,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { fonts } from '../../assets/jss'
const useStyles = makeStyles((theme) => ({
    settingsList: {
        backgroundColor: 'white',
        color: 'black'
    },
    listItem: {
        paddingLeft: 12
    },
    header: {
        ...fonts.secondary
    }
}));

function Settings() {
    const classes = useStyles();
    const { state, reducers } = useContext(store);
    const [collapse, setCollapse] = useState({
        ui: false,
        user: false
    })

    const handleCollapse = (key) => () => {
        setCollapse({ ...collapse, [key]: collapse[key] ? false : true })
    }

    const handleUserSettings = (key) => () => {
        if (state.user.isAnonymous) {
            window.alert('This feature is only available to logged in users.');
            return;
        }
        switch (key) {
            case 'displayName':
                reducers.handleModals('changeDisplayName', true)
                break;
            case 'email':
                reducers.handleModals('changeEmail', true);
                break;
            case 'password':
                reducers.handleModals('changePassword', true);
                break;
            case 'sendVerificationEmail':
                reducers.handleModals('sendVerificationEmail', true);
                break;
            default:
                reducers.handleModals('deleteAccount', true);
                break;
        }
    }

    return (
        <AppHeader>
            <h2 className={classes.header}> Settings</h2>
            <Grid container justify='center'>
                <Grid item xs={12} sm={10} lg={6}
                    className={classes.settingsList}>
                    <List>
                        <ListItem button onClick={handleCollapse(`ui`)}>
                            <ListItemText>
                                UI Settings
                            </ListItemText>
                            <ListItemIcon>
                                {collapse.ui ? <ExpandLess /> : <ExpandMore />}
                            </ListItemIcon>
                        </ListItem>
                        <Collapse in={collapse.ui}>
                            <ChangeUISettings />
                        </Collapse>
                        <Divider />
                        <ListItem button onClick={handleCollapse(`user`)}>
                            <ListItemText>
                                Profile Settings
                            </ListItemText>
                            <ListItemIcon>
                                {collapse.user ? <ExpandLess /> : <ExpandMore />}
                            </ListItemIcon>
                        </ListItem>
                        <Collapse in={collapse.user}>
                            <ListItem>
                                <ListItemText className={classes.listItem}>
                                    Change user name
                                </ListItemText>
                                <EditSettings onClick={handleUserSettings('displayName')} />
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.listItem}>
                                    Change email
                                </ListItemText>
                                <EditSettings onClick={handleUserSettings('email')} />
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.listItem}>
                                    Resend verification email
                                </ListItemText>
                                <EditSettings onClick={handleUserSettings('sendVerificationEmail')} />
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.listItem}>
                                    Change password
                                </ListItemText>
                                <EditSettings onClick={handleUserSettings('password')} />
                            </ListItem>
                            <ListItem>
                                <ListItemText className={classes.listItem}>
                                    Delete account
                                </ListItemText>
                                <EditSettings onClick={handleUserSettings()} />
                            </ListItem>
                        </Collapse>
                    </List>
                </Grid>
            </Grid>
        </AppHeader>
    );
}

export default Settings;
